import { useMutation } from '@tanstack/react-query';
import { deleteTag } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useDeleteTagMutation = () =>
  useMutation({
    mutationFn: async (id: ID) => deleteTag(id),
  });
